<template>
  <div class="atlas-detail">
    <JumpHeader />
    <van-swipe class="swipe-class" autoplay="5000" indicator-color="#fff" @change="swipeChange">
      <van-swipe-item v-for="item in collectionList" :key="item.operateId">
        <img class="img-class" :src="item.operatePic" alt="" />
      </van-swipe-item>
      <template #indicator="{ active, total }">
        <div class="custom-indicator">
          <div
            :class="['indicator-item', active === index && 'indicator-item-active']"
            v-for="(indi, index) in total"
            :key="index"
          ></div>
        </div>
      </template>
    </van-swipe>
    <div class="right-tools">
      <div class="tool-item" @click="failToast">
        <van-icon name="like" size="30px" />
        <span>{{ collectionDetail.clickSum }}</span>
      </div>
      <div class="tool-item" @click="failToast">
        <van-icon name="chat" size="30px" />
        <span>{{ collectionDetail.praiseSum }}</span>
      </div>
      <div class="tool-item" @click="failToast">
        <van-icon name="star" size="30px" />
        <span>{{ collectionDetail.collectSum }}</span>
      </div>
      <div class="tool-item" @click="failToast">
        <van-icon name="share" size="30px" />
        <span>{{ collectionDetail.shareSum }}</span>
      </div>
    </div>
    <div class="left-info">
      <div class="account">
        <img :src="collectionDetail.publishPic" alt="" />
        <span>{{ collectionDetail.publishName }}</span>
        <div class="focus" @click="failToast">关注</div>
      </div>
      <!-- <div class="title">{{ collectionList[swipeActiveNum]?.title }}</div> -->
      <div class="title">--</div>
      <div class="date">{{ collectionDetail.createTime }}</div>
      <div class="collection-name">
        <van-icon name="bars" size="20px" /><span
          >{{ collectionDetail.title }}{{ collectionList.length }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import wxSdk from "@/http/wxApi.js";
import JumpHeader from "@/components/Base/JumpHeader";
import { queryCollectionById, queryByCollectionIdList } from "@/http/api";

export default {
  name: "AtlasDetail",
  components: {
    JumpHeader,
  },
  data() {
    return {
      swipeActiveNum: 0,
      collectionId: null,
      collectionList: [],
      collectionDetail: {},
    };
  },
  mounted() {
    this.collectionId = this.$route.query.id;
    this.getDetail();
    this.queryList();
  },
  methods: {
    async getDetail() {
      const { data } = await queryCollectionById({
        id: this.collectionId,
      });
      this.collectionDetail = data;
      document.title = data.title ? data.title : "花城+";
      this.wxShare();
    },
    // 查询图集列表
    async queryList() {
      const { data } = await queryByCollectionIdList({
        collectionId: this.collectionId,
      });
      this.collectionList = data.records;
      console.log(this.collectionList);
    },
    swipeChange(num) {
      this.swipeActiveNum = num;
    },
    wxShare() {
      const _detail = this.collectionDetail;
      wxSdk.getJSSDK({
        title: _detail.title,
        desc: _detail.publishName,
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/atlasDetail?id=${_detail.id}`,
        img: _detail.publishPic,
      });
    },
    failToast() {
      Toast.fail("请先下载APP");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.swipe-class {
  width: 100%;
  height: 100vh;

  .img-class {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 0 0;
  }

  .custom-indicator {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 18px;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;

    .indicator-item {
      width: 100%;
      flex: 1;
      height: 3px;
      background: #ffffff73;
      margin-right: 3px;
      border-radius: 4px;

      &:last-child {
        margin-right: 0;
      }
    }

    .indicator-item-active {
      background: #fff;
    }
  }
}

.right-tools {
  position: fixed;
  right: 10px;
  bottom: 50px;
  width: 50px;
  height: 280px;

  .tool-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 70px;
    color: #fff;

    & > span {
      display: inline-block;
      font-size: 14px;
      margin-top: 3px;
    }
  }
}

.left-info {
  position: fixed;
  bottom: 70px;
  left: 20px;

  .account {
    display: flex;
    align-items: center;

    & > img {
      width: 35px;
      height: 35px;
      border-radius: 50%;
    }

    & > span {
      color: #ffffffd9;
      font-size: 14px;
      margin-left: 3px;
    }

    .focus {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffffd9;
      font-size: 14px;
      width: 50px;
      height: 20px;
      border: 1px solid #ffffffd9;
      border-radius: 15px;
      margin-left: 10px;
    }
  }

  .title {
    font-size: 16px;
    color: #fff;
    margin: 10px 0;
  }

  .date {
    color: #ffffffa6;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .collection-name {
    display: flex;
    align-items: center;
    color: #fff;

    & > span {
      font-size: 14px;
      margin-left: 3px;
    }
  }
}
</style>
